import MyAccountProfilePage from './MyAccountProfilePage'

export default MyAccountProfilePage
// eslint-disable-next-line import/export
export * from './MyAccountProfilePage'
